import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { ControlType, DynamicField } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';
import DynamicDisplay from 'components/common/display/DynamicDisplay';
import { withRights } from 'providers/RightsConsumer';
import { getDateFormat, getDateValue, getDynamicFieldControlType } from 'utils/functions';

class OfferPartnerIncomeDataItemComponent extends React.PureComponent {
  getPeriodDateFormat = periodType => {
    switch (periodType) {
      case 'YEAR':
        return 'YYYY';
      case 'MONTHYEAR':
        return 'MMMM-YYYY';
      default:
        return 'L';
    }
  };

  render() {
    const { t, data, editable, loadDetailOptions, onPeriodChange, onChange, rights, idx, cardIndex } = this.props;

    return (
      <>
        <Grid item xs={12} sm={4} md={4}>
          <span id={'offerPartnerIncomeDataCard_' + cardIndex + '_' + idx + '_name'}>{data.name} </span>
        </Grid>
        {editable && data.periodType ? (
          <Grid item xs={12} sm={4} md={4}>
            <DateTime
              id={'offerPartnerIncomeDataCard_' + cardIndex + '_' + idx + '_period'}
              controlType={getDynamicFieldControlType(data.typeCode)}
              onChange={value => onPeriodChange(data.incomeTypeDetailId, getDateValue(value))}
              value={data.period}
              closeOnSelect={true}
              disabled={rights.readOnlyFull || data.readOnly || !rights.clientIncomeSourcesWrite || !rights.anafPfaIncomeWrite}
              format={getDateFormat()}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={4} md={4}>
            <span id={'offerPartnerIncomeDataCard_' + cardIndex + '_' + idx + '_period'}>
              {' '}
              {data.period ? t('DATE_FORMAT', { date: { value: data.period, format: this.getPeriodDateFormat(data.periodType) } }) : ''}
            </span>
          </Grid>
        )}

        {editable ? (
          <Grid item xs={12} sm={4} md={4}>
            <DynamicField
              id={'offerPartnerIncomeDataCard_' + cardIndex + '_' + idx + '_value'}
              controlType={getDynamicFieldControlType(data.typeCode)}
              onChange={value =>
                onChange(
                  data.incomeTypeDetailId,
                  getDynamicFieldControlType(data.typeCode) === ControlType.Date ? getDateValue(value) : value?.toString()
                )
              }
              value={data.value || ''}
              disabled={rights.readOnlyFull || data.readOnly || !rights.clientIncomeSourcesWrite || !rights.anafPfaIncomeWrite}
              loadOptions={loadDetailOptions}
              format={getDateFormat()}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={4} md={4}>
            <DynamicDisplay
              id={'offerPartnerIncomeDataCard_' + cardIndex + '_' + idx + '_value'}
              type={data.typeCode}
              value={data.value || ''}
            />
          </Grid>
        )}
      </>
    );
  }
}

OfferPartnerIncomeDataItemComponent.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  loadDetailOptions: PropTypes.func,
  editable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  cardIndex: PropTypes.number
};

export default compose(withTranslation())(withRights(OfferPartnerIncomeDataItemComponent));
